// @ts-expect-error no types
import { catchAndRethrowNetworkError } from 'crm_data/bCommerce/monitoring/errorUtils';
import paymentsTimeoutApiClient from 'growth-payments-core/api/paymentsTimeoutApiClient';
const TOS_ENDPOINT = 'payments/v1/tos';
export const setTosAcceptance = () => paymentsTimeoutApiClient.post(`${TOS_ENDPOINT}`).catch(catchAndRethrowNetworkError);